import "../../assets/scss/create-target.scss";

import { useAuth } from "../../hooks/useAuth";
import { useQuery } from "react-query";
import {
  customerFullName,
  fetchActionsUtil,
  formatDateTime,
} from "../../utils/helpers";

import currency from "currency.js";
import TableComponent from "../TableComponent";
import { Modal } from "react-bootstrap";

const TargetPerformanceModal = ({ show, setShow, title, id }) => {
  const { backendUrl } = useAuth();

  const { data } = useQuery(
    ["VIEW_TARGET_PERFORMANCE", id],

    () =>
      fetchActionsUtil(`${backendUrl}/api/company/target-performance/${id}`),
    { onSuccess: (data) => {} },
    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  console.log("this is the dstata ==== ", data);

  const tableHead = () => {
    return (
      <thead className="position-sticky top-0">
        <tr>
          <th>Customer Name</th>
          <th>Target Amount</th>
          <th>Amount Realized</th>
          <th>Progress</th>
        </tr>
      </thead>
    );
  };

  const tableData = (el, index) => {
    return (
      <>
        <td>{customerFullName(el?.customers)}</td>

        <td>
          {currency(Number(el?.targetAmount)).format({
            symbol: "",
            separator: "",
          })}
        </td>
        <td>
          {currency(Number(el?.total)).format({
            symbol: "",
            separator: "",
          })}
        </td>
        <td>{el?.progress}%</td>
      </>
    );
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      animation={false}
      enforceFocus={false}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h5>{title}</h5>
          <p className={"subtitle"}>View the performance of each customer </p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={"container"}>
          <div className="px-md-4">
            <TableComponent
              responsive
              borderless
              striped
              tableHeadsFunction={tableHead}
              mainDataArray={data?.data?.eachCustomerTarget || []}
              className="product-table text-nowrap"
              tableDataRowFunction={tableData}
              // tableRowClick={(e, el) => manageTransaction(e, el)}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TargetPerformanceModal;
